import $http from "@/plugins/axios"

export default {
    state: {
        all_patient_data: [],
    },
    getters: {
        all_patient_data: state => state.all_patient_data
    },
    actions: {
        async getPatient({ commit }, path) {
            const response = await $http.get(path)
            commit("SET_ITEMS", response.data)
        },
    },
    mutations: {
        SET_ITEMS(state, data) {
            state.all_patient_data = data
        },
    }
}